import {inject} from 'aurelia-framework';
import {DialogController, DialogService} from 'aurelia-dialog';
import {filter} from 'lodash';

@inject(Element, DialogController)
export class AddMemberResult {

  summary: boolean = true;
  action: string;
  profilesArray: any[];
  goodRecords: any;
  badRecords: any;


  constructor(public element: Element, public dialogCtrl: DialogController) {
    this.element = element;
    this.dialogCtrl = dialogCtrl;
    this.summary = true;
  }
  activate(model) {
    this.action = model.action ? model.action : '';
    this.profilesArray = model.profilesArray ? model.profilesArray : [];
    this.goodRecords = filter(this.profilesArray, {error: false});
    this.badRecords = filter(this.profilesArray, {error: true});
  }
  getMoreDetails() {
    this.summary = false;
  }
  close() {
    // @ts-ignore
    this.dialogCtrl.close();
  }
}
